import { render } from "./DemoBanner.vue?vue&type=template&id=5ad11ffe&scoped=true"
const script = {}

import "./DemoBanner.vue?vue&type=style&index=0&id=5ad11ffe&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ad11ffe"]])

export default __exports__